import Timeline from 'antd/lib/timeline';

export default Timeline;
